import { priceField } from '../../../components/table/CommonFields';

const fields = {
  config: { columns: 2 },
  fields: [
    {
      name: 'total',
      type: 'unvisible',
    },
    {
      name: 'paymentOnBookingPercentage',
      label: 'Zaliczka przy rezerwacji',
      column: 1,
      suffix: '%',
      maxValue: 100,
      defaultValue: '30',
      scale: 4,
      mandatory: true,
      type: 'number',
      autoComplete: {
        triggers: ['paymentOnBooking', 'total'],
        calculation: function (paymentOnBooking, total) {
          console.log('[AUTO-CALC] paymentOnBooking:', paymentOnBooking);
          console.log('[AUTO-CALC] total:', total);

          const booking = parseFloat(paymentOnBooking);
          const totalAmount = parseFloat(total);

          console.log('[AUTO-CALC] parsed booking:', booking);
          console.log('[AUTO-CALC] parsed totalAmount:', totalAmount);

          if (!isNaN(booking) && !isNaN(totalAmount) && totalAmount !== 0) {
            const percentage = (booking / totalAmount) * 100;
            const rounded = Number(percentage.toFixed(4));
            console.log('[AUTO-CALC] calculated percentage:', rounded);

            if (rounded > 100) {
              console.warn('[AUTO-CALC] percentage > 100%, returning empty');
              return '';
            }

            return rounded;
          }

          console.warn('[AUTO-CALC] Invalid values, returning empty');
          return '';
        },
      },
    },

    priceField(2, 'paymentOnBooking', 'Wylicz dla kwoty', false, '0'),
  ],
};

export default fields;
